import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { Enums } from '../../../../../../../configs/Enums';
import { TICKETS_PATHS } from '../../../../../../tickets/tickets';
import { TicketsService } from '../services/tickets.service';
import { WorkShiftService } from '../../../../../work-shift.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-grs-list-new',
  templateUrl: './tickets-grs-list.component.html',
  styleUrls: ['./tickets-grs-list.component.scss'],
  providers: [TicketsService],
  standalone: false,
})
export class TicketsGrsListComponent implements AfterViewInit, OnDestroy {
  get appliedTypeGPs() {
    if (!this.ticketsPeriodFilter.appliedSubtypeGPs.length) {
      return [];
    }

    const selectedTypeGPs = this.ticketsPeriodFilter.appliedTypeGPs.filter((gp) => gp.selected);
    const accidentTypeGP = selectedTypeGPs.find((typeGP) => typeGP.name.toLowerCase().includes('авария'));

    if (!accidentTypeGP) {
      return selectedTypeGPs;
    }

    return [accidentTypeGP, ...selectedTypeGPs.filter((typeGP) => typeGP.id !== accidentTypeGP.id)];
  }

  get appliedSubtypeGPs() {
    return this.ticketsPeriodFilter.appliedSubtypeGPSelected;
  }

  constructor(
    private ticketsService: TicketsService,
    private workShiftService: WorkShiftService
  ) {}
  @ViewChild('ticketsList') ticketsListEl;

  public Enums = Enums;
  public moment = require('moment');
  public TICKETS_PATHS = TICKETS_PATHS;
  public dateShortFormat = Enums.dates.shortFormat;
  public currentDate = this.moment().startOf('day').format(this.dateShortFormat);
  public isOpenTicketsBrigadeAssignPopover: boolean;
  public ticketBrigadePopoverOpen: any;
  public listHeight = 0;
  public destroyer = new Subject<void>();

  @Input() ticketsCurrentFilter;
  @Input() ticketsPeriodFilter;
  @Input() ticketsMultipleAssign;
  @Input() tickets;
  @Input() filter;
  @Input() brigadeAssign;

  @ViewChild('wrapperHeader') wrapperHeader: ElementRef;
  @ViewChild('ticketsListHeader')
  ticketsListHeader: ElementRef;

  ngAfterViewInit() {
    setTimeout(() => {
      this.checkListHeight();
    }, 10);
    this.workShiftService.filterCollapse$.pipe(debounceTime(500), takeUntil(this.destroyer)).subscribe(() => {
      this.checkListHeight();
    });
  }

  public checkListHeight() {
    if (this.ticketsListEl && this.ticketsListEl.nativeElement) {
      const rect = this.ticketsListEl.nativeElement.getBoundingClientRect();
      this.listHeight = Math.min(document.documentElement.clientHeight - rect.top - 70, 500);
    }

    return this.listHeight;
  }

  public changeStateOpened(district): void {
    Object.defineProperty(district, 'isOpened', {
      value: !district.isOpened,
    });
  }

  public onOpenTicketBrigadeAssignPopover(state): void {
    this.isOpenTicketsBrigadeAssignPopover = state.state;
    this.ticketBrigadePopoverOpen = state.ticket;
  }

  public showNoData() {
    return this.appliedTypeGPs.every((appliedTypeGP) => !this.hasTickets(this.tickets.dataTable, appliedTypeGP, this.appliedSubtypeGPs));
  }

  public hasTickets(...args): boolean {
    return this.ticketsService.hasTickets.apply(this.ticketsService, args);
  }

  public filterBy(...args) {
    return this.ticketsService.filterBy.apply(this.ticketsService, args);
  }

  public ngOnDestroy() {
    this.destroyer.next();
    this.destroyer = null;
  }
}
